function findDuplicateName(target: { companyId: string, siteId: string, name: string }, sites: Site[]): boolean {
  const companySites = sites.filter(el => el.companyId === target.companyId && el.siteId !== target.siteId);
  const val = companySites.find(el => el.name === target.name);
  return val !== undefined;
}

export default findDuplicateName;
